import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import "../../assets/css/new-website.css";
import { useLocation } from "react-router-dom";

const validationSchema = Yup.object({
  username: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  phone: Yup.string().matches(/^[0-9]{10}$/, "Phone number must be 10 digits").required("Phone number is required"),
  message: Yup.string().required("Message is required"),
  agree: Yup.boolean().oneOf([true], "You must accept the terms and conditions"),
});

const ReachToUsForm = ({ submitted }) => {
  const [thank, setThank] = useState(false);
  const location = useLocation();
  const slug = location.pathname.replace(/^\/|\/$/g, '') || 'home';

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const contactData = {
        Name: values.username,
        Email: values.email,
        Phone: values.phone,
        Message: values.message,
        Page_Slug: slug,
      };

      // 1. Send to Strapi
      const res = await axios.post(`https://admin.bridgehealth.in/api/contact-forms`, { data: contactData });

      // 2. Send to Google Sheet using FormData (to avoid CORS preflight)
      const urlData = new URLSearchParams();
      Object.entries(contactData).forEach(([key, val]) => urlData.append(key, val));

      await fetch("https://script.google.com/macros/s/AKfycbxWuiJ6EYHGeut503pfGqVvBObwb8vM18GOn5Gsp-3RqSo376pTbdVjGp6JTmRJorZbvA/exec", {
        method: "POST",
        headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        },
        body: urlData.toString(),
      })
        .then(res => res.json())
        .then(data => console.log("Google Sheet success:", data))
        .catch(err => console.error("Google Sheet error:", err));

      if (res.status === 200) {
        setThank(true);
        resetForm();
        setTimeout(() => {
          setThank(false);
          submitted();
        }, 3000);
      }
    } catch (error) {
      console.log("Error submitting:", error);
    }
  };

  return (
    <div className="px-1 py-1">
      <Formik
        initialValues={{ username: "", email: "", phone: "", message: "", agree: true }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form className="def-new-form row">
            <div className="col-lg-12">
              <Field name="username" type="text" className="form-control" placeholder="Name*" />
              <ErrorMessage name="username" component="div" className="error" />
            </div>
            <div className="col-lg-6">
              <Field name="email" type="email" className="form-control" placeholder="Email*" />
              <ErrorMessage name="email" component="div" className="error" />
            </div>
            <div className="col-lg-6">
              <Field name="phone" type="text" className="form-control" placeholder="Phone*" />
              <ErrorMessage name="phone" component="div" className="error" />
            </div>

            {/* Hidden fields */}
            <Field name="Lead_Source" type="hidden" value="Website" />
            <Field name="Page_Slug" type="hidden" value={slug} />

            <div className="col-lg-12">
              <Field
                name="message"
                as="textarea"
                className="form-control"
                placeholder="Message"
                style={{ height: '400px' }}
              />
              <ErrorMessage name="message" component="div" className="error" />
            </div>

            <div className="col-lg-12">
              <div className="form-check-v3 d-none">
                <Field
                  name="agree"
                  type="checkbox"
                  className="checkBoxNew"
                  id="agreeCheckbox"
                  checked={true}
                />
                <label className="ms-2 p-0 m-0" htmlFor="agreeCheckbox">
                  I agree that Bridge Health may contact me at the email address or phone number above.
                </label>
              </div>
              <ErrorMessage name="agree" component="div" className="error" />
            </div>

            <div className="d-flex justify-content-center align-items-center w-100">
              <button type="submit" className="form-btn" disabled={isSubmitting}>
                Submit Now
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {thank && <div className="mt-4 text-center">Thanks for reaching out!</div>}
    </div>
  );
};

export default ReachToUsForm;
